import { createSlice } from "@reduxjs/toolkit"
import { uuid } from "uuidv4"

const initialState = {
	form: {
		nome: "",
		folhasDeVerificacao: [],
		camposDeVerificacao: [],
		folha: null,
		actualPage: 0,
		planoDeControle: "",
		processo: "",
		attachment: "default:default",
		planoDeControleRefId: null
	},
	cadernos: [],
	cadernoView: {
		caderno: {}, // Definição estrutural (campos e controles)
		activeFolha: null, // A folha sendo visualizada atualmente
		paginaAtual: 0,
		data: "",
		pagesToSave: [],
		folhasInfo: []
	},
}
//receive state && action, auto-stract form && payload
function searchIndexCampo({ form }, { payload }) {
	if (payload.id) return form.camposDeVerificacao.findIndex(c => c.id === payload.id)
	return form.camposDeVerificacao.findIndex(c => c.__id === payload.__id)
}

const cadernoDeVerificacaoReducer = createSlice({
	name: "cadernoDeVerificacaoReducer",
	initialState,
	reducers: {
		setFiltro(state, action) {
			state.form.filtro = action.payload
		},
		setNome(state, action) {
			state.form.nome = action.payload
		},
		setProcesso(state, action) {
			state.form.processo = action.payload
		},
		setCadernos(state, action) {
			state.cadernos = action.payload
		},
		setUpdateCadernoRow(state, action) {
			let index = state.cadernos.findIndex(
				(c) => c.id == action.payload.id
			)
			state.cadernos[index] = action.payload
		},
		setCadernoView(state, action) {
			state.cadernoView = {
				caderno: {},
				activeFolha: null,
				paginaAtual: 0,
				data: "",
				pagesToSave: [],
				folhasInfo: []
			}
			state.cadernoView.caderno = action.payload.caderno || action.payload
			// If activeFolha is passed in payload
			if (action.payload.activeFolha) {
				state.cadernoView.activeFolha = action.payload.activeFolha
			}
		},
		setFolhasInfo(state, action) {
			state.cadernoView.folhasInfo = action.payload || []
		},
		setActiveFolha(state, action) {
			state.cadernoView.activeFolha = action.payload
		},
		setUpdateSingleFolha(state, action) {
			// Now updates activeFolha if ids match, otherwise ignores
			if (state.cadernoView.activeFolha && state.cadernoView.activeFolha.id === action.payload.id) {
				state.cadernoView.activeFolha = action.payload
			}
		},
		setUpdateSingleRegistro(state, action) {
			// Update only in activeFolha since we don't keep others
			if (state.cadernoView.activeFolha && state.cadernoView.activeFolha.id === action.payload.folhaDeVerificacaoId) {
				const index = state.cadernoView.activeFolha.registrosDeCampo.findIndex((r) => r.id == action.payload.id)
				if (index !== -1) {
					state.cadernoView.activeFolha.registrosDeCampo[index] = action.payload
				}
			}
		},
		setData(state, action) {
			if (state.cadernoView.activeFolha) {
				state.cadernoView.activeFolha.data = action.payload
			}
		},
		setFolhasDeVerificacao(state, action) {
			// Deprecated or redirect to activeFolha if single array?
			// For now, let's assume if we receive a list, we might want to set active if it matches?
			// But sticking to the goal: removing list from structure. 
			// If this action is called, we probably should ignore or update activeFolha if it finds it.
			// Ideally this shouldn't be called anymore with the new logic.
			// state.cadernoView.folhasDeVerificacao = action.payload
		},
		setCamposDeVerificacao(state, action) {
			state.form.camposDeVerificacao = action.payload
		},
		setMarkCampo(state, action) {
			let { campo, checked } = action.payload
			let index = state.form.camposDeVerificacao.findIndex(c => campo.id ? c.id === campo.id : c.__id === campo.__id)
			if (index >= 0) {
				state.form.camposDeVerificacao[index].checked = checked
			}
		},
		setTipoDeCampo(state, action) {
			let { campo, tipoDeCampo } = action.payload
			let index = state.form.camposDeVerificacao.findIndex(c => campo.id ? c.id === campo.id : c.__id === campo.__id)
			if (index >= 0) {
				state.form.camposDeVerificacao[index].tipoDeCampo = tipoDeCampo
			}
		},
		setPosicao(state, action) {
			let { campo, valor } = action.payload
			let index = state.form.camposDeVerificacao.findIndex(c => campo.id ? c.id === campo.id : c.__id === campo.__id)
			if (index >= 0) {
				state.form.camposDeVerificacao[index].posicao = valor
			}
		},
		setFormulaCampoDeVerificacao(state, action) {
			let { index, formula } = action.payload
			state.form.camposDeVerificacao[index].formula = formula
		},
		setRegraDeCorrecao(state, action) {
			let { index, campo } = action.payload
			state.form.camposDeVerificacao[index].campo = campo
			state.form.camposDeVerificacao[index].campoId = campo.id
		},
		addCampo(state, action) {
			if (Array.isArray(action.payload)) state.form.camposDeVerificacao = [...state.form.camposDeVerificacao, ...action.payload]
			else state.form.camposDeVerificacao = [...state.form.camposDeVerificacao, action.payload]
		},
		updateCampoDeVerificacao(state, action) {
			let index = searchIndexCampo(state, action)
			console.log('updateCampoDeVerificacao - index encontrado:', index, 'payload:', action.payload)
			if (index < 0) {
				// Campo não encontrado, adicionar ao array
				console.log('Campo não encontrado, adicionando novo')
				state.form.camposDeVerificacao.push(action.payload)
				return
			}
			// Campo encontrado, atualizar no índice específico
			console.log('Campo encontrado no índice', index, 'atualizando...')
			state.form.camposDeVerificacao[index] = action.payload

			// Reaplica a posicao nos campos
			state.form.camposDeVerificacao.sort((a, b) => (a.posicao || 0) - (b.posicao || 0))


		},
		setPlano(state, action) {
			state.form.planoDeControle = action.payload
			state.form.attachment = "planoDeControle:" + action.payload.id
			state.form.planoDeControleRefId = action.payload.refId
		},
		addFolhaDoCadernoView(state, action) {
			// Now updates activeFolha if page number matches
			if (state.cadernoView.activeFolha &&
				state.cadernoView.activeFolha.numeroDaPagina == action.payload.numeroDaPagina) {
				state.cadernoView.activeFolha = action.payload
			}
		},
		setValorRegistro(state, action) {
			if (state.cadernoView.activeFolha) {
				let indexCampo = state.cadernoView.activeFolha.registrosDeCampo.findIndex(rc => rc._localId == action.payload._localId)
				if (indexCampo !== -1) {
					const currentRegistro = state.cadernoView.activeFolha.registrosDeCampo[indexCampo]

					if (typeof currentRegistro._initialValor === 'undefined') {
						currentRegistro._initialValor = currentRegistro.valor;
					}

					let novoValor = action.payload.valor;

					// Normalização para comparação robusta (trata null/undefined como "")
					const normalize = (val) => (val === null || val === undefined) ? "" : String(val).trim();

					const isZeroLike = (val) => val === 0 || val === "0" || val === "0.00" || val === "";

					// Verifica se o valor divergiu do inicial, se é um valor "zero" (força change) ou se as justificativas foram alteradas
					let isChanged = normalize(currentRegistro._initialValor) !== normalize(novoValor) ||
						isZeroLike(novoValor) ||
						JSON.stringify(currentRegistro.justificativas) !== JSON.stringify(action.payload.justificativas);

					state.cadernoView.activeFolha.registrosDeCampo[indexCampo] = {
						...action.payload,
						_initialValor: currentRegistro._initialValor,
						changed: isChanged,
						data: isChanged ? new Date().toISOString() : currentRegistro.data
					}

					if (isChanged) {
						if (!state.cadernoView.pagesToSave) {
							state.cadernoView.pagesToSave = []
						}
						if (!state.cadernoView.pagesToSave.includes(state.cadernoView.paginaAtual)) {
							state.cadernoView.pagesToSave = [...state.cadernoView.pagesToSave, state.cadernoView.paginaAtual]
						}
					}
				}
			}
		},
		setValorRegistroDeCampo(state, action) {
			let { registro, valor } = action.payload
			if (state.cadernoView.activeFolha) {
				let indexCampo = state.cadernoView.activeFolha.registrosDeCampo.findIndex(
					rc => rc._localId == registro._localId
				)
				if (indexCampo !== -1) {
					const currentRegistro = state.cadernoView.activeFolha.registrosDeCampo[indexCampo]

					if (typeof currentRegistro._initialValor === 'undefined') {
						currentRegistro._initialValor = currentRegistro.valor;
					}

					// Normalização para comparação robusta (trata null/undefined como "")
					const normalize = (val) => (val === null || val === undefined) ? "" : String(val).trim();

					const isZeroLike = (val) => val === 0 || val === "0" || val === "0.00" || val === "";

					// Verifica se o valor atual é diferente do valor inicial ou se é um valor "zero" (força change)
					if (normalize(currentRegistro._initialValor) !== normalize(valor) || isZeroLike(valor)) {
						currentRegistro.changed = true
						currentRegistro.data = new Date().toISOString()
					} else {
						currentRegistro.changed = false
					}

					if (currentRegistro.changed) {
						if (!state.cadernoView.pagesToSave) {
							state.cadernoView.pagesToSave = []
						}
						if (!state.cadernoView.pagesToSave.includes(state.cadernoView.paginaAtual)) {
							state.cadernoView.pagesToSave.push(state.cadernoView.paginaAtual)
						}
					}
					currentRegistro.valor = valor
				}
			}
		},
		setUsuariorRegistroDeCampo(state, action) {
			let { registro, usuario } = action.payload
			let { id, nome } = usuario
			if (state.cadernoView.activeFolha) {
				let indexCampo = state.cadernoView.activeFolha.registrosDeCampo.findIndex(rc => rc._localId == registro._localId)
				if (indexCampo !== -1) {
					state.cadernoView.activeFolha.registrosDeCampo[indexCampo].userId = id
					state.cadernoView.activeFolha.registrosDeCampo[indexCampo].nomeUsuario = nome
				}
			}
		},
		checkRegistroFromCaderno(state, action) {
			let { registro, checked } = action.payload
			if (state.cadernoView.activeFolha) {
				let indexCampo = state.cadernoView.activeFolha.registrosDeCampo.findIndex(rc =>
					rc._localId === registro._localId || (rc.id && rc.id === registro.id)
				)
				if (indexCampo !== -1) {
					state.cadernoView.activeFolha.registrosDeCampo[indexCampo].checked = checked
				}
			}
		},
		setErrorMessage(state, action) {
			let { registro, errorMessage } = action.payload
			if (state.cadernoView.activeFolha) {
				let indexCampo = state.cadernoView.activeFolha.registrosDeCampo.findIndex(rc => rc._localId == registro._localId)
				if (indexCampo !== -1) {
					state.cadernoView.activeFolha.registrosDeCampo[indexCampo].errorMessage = errorMessage
				}
			}
		},
		setStyleObject(state, action) {
			let { registro, style } = action.payload
			if (state.cadernoView.activeFolha) {
				let indexCampo = state.cadernoView.activeFolha.registrosDeCampo.findIndex(rc => rc._localId == registro._localId)
				if (indexCampo !== -1) {
					state.cadernoView.activeFolha.registrosDeCampo[indexCampo].style = style
				}
			}

		},
		addRegistroDeCampoChild(state, action) {
			const { fatherRegistro } = action.payload

			if (state.cadernoView.activeFolha) {
				// 2) Cria um novo registro copiando algumas propriedades do 'fatherRegistro'
				const novoRegistro = {
					...fatherRegistro,
					id: undefined, // agora é um registro "novo" sem ID
					fatherId: fatherRegistro.id,
					_localId: uuid(),
					data: new Date().toISOString(),
					valor: "",
					isLate: false,
					style: undefined,
					errorMessage: undefined,
					justificativas: [],
				}

				// Pega a lista de registros de campo da folha
				const registros = state.cadernoView.activeFolha.registrosDeCampo

				// 3) Descobre em qual posição o fatherRegistro está (usando indexOf).
				//    O indexOf faz a comparação, mas não precisamos usar '===' explicitamente.
				const fatherIndex = registros.findIndex(r => fatherRegistro._localId == r._localId)

				// Se encontrar o pai, insere logo depois dele; caso não encontre, push no final
				if (fatherIndex >= 0) {
					registros.splice(fatherIndex + 1, 0, novoRegistro)
				} else {
					// Caso, por algum motivo, a referência não seja a mesma, faz push
					registros.push(novoRegistro)
				}

				// 4) Marca que essa página precisa ser salva (pagesToSave)
				if (!state.cadernoView.pagesToSave) {
					state.cadernoView.pagesToSave = []
				}
				if (!state.cadernoView.pagesToSave.includes(state.cadernoView.paginaAtual)) {
					state.cadernoView.pagesToSave.push(state.cadernoView.paginaAtual)
				}
			}
		},
		replaceFolha(state, action) {
			let folha = action.payload
			// Update activeFolha if it matches
			if (state.cadernoView.activeFolha &&
				(state.cadernoView.activeFolha.id === folha.id ||
					state.cadernoView.activeFolha.numeroDaPagina == folha.numeroDaPagina)) {
				state.cadernoView.activeFolha = folha
			}

			if (!state.cadernoView.pagesToSave) {
				state.cadernoView.pagesToSave = []
			}
			if (!state.cadernoView.pagesToSave.includes(folha.numeroDaPagina)) {
				state.cadernoView.pagesToSave.push(folha.numeroDaPagina)
			}
		},
		checkAllRegistroFromFolha(state, action) {
			let { folha, checked } = action.payload
			if (state.cadernoView.activeFolha && state.cadernoView.activeFolha.id === folha.id) {
				state.cadernoView.activeFolha.registrosDeCampo = state.cadernoView.activeFolha.registrosDeCampo.map(rc => ({ ...rc, checked: rc.id ? checked : false }))
			}
		},

		updateByFolhaId(state, action) {
			//acha a folha de verificacao pelo id e atualiza
		},
		setJustificativa(state, action) {
			let { indexRegistro, justificativas } = action.payload
			if (state.cadernoView.activeFolha) {
				state.cadernoView.activeFolha.registrosDeCampo[indexRegistro] = justificativas
			}
		},
		populateJustificativasRegistroDeCampo(state, action) {
			if (state.cadernoView.activeFolha) {
				state.cadernoView.activeFolha.registrosDeCampo[action.payload.indexRegistro].justificativas =
					action.payload.justificativas
			}
		},
		removeJustificativaFromRegistro(state, action) {
			if (state.cadernoView.activeFolha) {
				state.cadernoView.activeFolha.registrosDeCampo[
					action.payload.indexRegistro
				].justificativas = state.cadernoView.activeFolha.registrosDeCampo[
					action.payload.indexRegistro
				].justificativas.filter(
					(j, i) => i != action.payload.indexJustificativa
				)
			}
		},
		setActualPage(state, action) {
			state.cadernoView.paginaAtual = action.payload
		},
		populateToEdit(state, action) {
			state.form = action.payload
		},
		clear(state, action) {
			state.form = initialState.form
		},
		clearPagesToSave(state) {
			state.cadernoView.pagesToSave = []
		},
		discardRegistroDeCampo(state, action) {
			const localId = action.payload;
			if (state.cadernoView.activeFolha) {
				const index = state.cadernoView.activeFolha.registrosDeCampo.findIndex(
					rc => rc._localId == localId
				);
				if (index !== -1) {
					const reg = state.cadernoView.activeFolha.registrosDeCampo[index];
					if (typeof reg._initialValor !== 'undefined') {
						reg.valor = reg._initialValor;
					}
					reg.changed = false;
				}
			}
		}
	},
})

export const {
	addRegistroDeCampoChild,
	setFiltro,
	populateToEdit,
	setUpdateCadernoRow,
	clear: clearCadernoDeVerificacaoForm,
	setData,
	setCadernoView,
	setValorRegistroDeCampo,
	populateJustificativasRegistroDeCampo,
	addCampo,
	removeJustificativaFromRegistro,
	setValorRegistro,
	setActualPage,
	updateCampoDeVerificacao,
	setJustificativa,
	setNome,
	setCamposDeVerificacao,
	setCadernos,
	setPlano,
	setFolhasDeVerificacao,
	setProcesso,
	setUpdateSingleRegistro,
	setUpdateSingleFolha,
	setFormulaCampoDeVerificacao,
	updateByFolhaId,
	addFolhaDoCadernoView,
	setRegraDeCorrecao,
	clearPagesToSave,
	setMarkCampo,
	setPosicao,
	setErrorMessage,
	setStyleObject,
	setTipoDeCampo,
	setActiveFolha,
	replaceFolha,
	checkRegistroFromCaderno,
	checkAllRegistroFromFolha,
	setUsuariorRegistroDeCampo,
	setFolhasInfo,
	discardRegistroDeCampo
} = cadernoDeVerificacaoReducer.actions
export default cadernoDeVerificacaoReducer.reducer
